import { render } from "./GroupBDetails.vue?vue&type=template&id=bd84a3ea&scoped=true"
import script from "./GroupBDetails.vue?vue&type=script&lang=js"
export * from "./GroupBDetails.vue?vue&type=script&lang=js"

import "./GroupBDetails.vue?vue&type=style&index=0&id=bd84a3ea&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd84a3ea"]])

export default __exports__